// import { useMemo } from 'react';
// import { GeoJsonLayer, ScatterplotLayer, TextLayer } from '@deck.gl/layers';
// import {DataFilterExtension} from '@deck.gl/extensions';
// import {CollisionFilterExtension} from '@deck.gl/extensions';
// import { sensorToColor } from '../utils/layer_style';
import { OGC_FUNCTIONS } from '../config';
import { useOGCJsonFunction } from '../utils/ogc';
import { useMemo } from 'react';


export type MaxPrecipDataFeatureProperties = {
    time: Date;
    precip_in_inches_5min: number;
};

export type MaxPrecipDataFeature = MaxPrecipDataFeatureProperties[]

export const transformMaxPrecipData = (d: MaxPrecipDataFeatureProperties) => {
    d.time = new Date(d.time);
    return d as MaxPrecipDataFeatureProperties;
}

export const useMaxPrecipData = (fromTime: Date, toTime: Date) => {
  const data = useOGCJsonFunction(
    OGC_FUNCTIONS.MAX_PRECIP_DATA, {
    from_time: fromTime.toISOString(),
    to_time: toTime.toISOString(),
    // 'time>= ': fromTime.toISOString(),
    // 'time<= ': toTime.toISOString(),
    limit: 1000,
    sortby: 'time',
  }) as { features: MaxPrecipDataFeatureProperties[] | undefined; loading: boolean; error: any };
  data.features = useMemo(() => data.features?.map(transformMaxPrecipData), [data.features]);
  return data;
};

// export default function useMaxPrecipDataLayer({ fromTime, toTime }: { fromTime: Date; toTime: Date }) {
//   const { features } = useMaxPrecipData(fromTime, toTime);

//   return (
//     !features ? null : 
//     new GeoJsonLayer({
//       id: 'max_precip_data',
//       data: { type: 'FeatureCollection', features },
//       // type: 'mvt',
//       // data: ['https://gis.dev.floodlabs.nyc/tiles/ogc.sensor_locations/{z}/{x}/{y}.pbf'],

//       pointRadiusUnits: 'pixels' as const,
//       stroked: true,
//       filled: true,
//       pickable: true,
//       autoHighlight: false,
//       // getLineColor: [0, 120, 200, 200],

//       getFillColor: (d: MaxPrecipDataFeature) => {
//         const precip = d.properties.precip_in_inches_5min;
//         if (precip >= 0.5) return [0, 0, 200, 200];
//         if (precip >= 0.2) return [0, 100, 200, 200];
//         if (precip >= 0.1) return [0, 150, 200, 200];
//         if (precip > 0) return [100, 200, 200, 200];
//         return [200, 200, 240, 200];
//       },

//       getRadius: 6,

//       extensions: [
//         new DataFilterExtension({ filterSize: 1 }),
//         // new CollisionFilterExtension(),
//       ],
//       dataFilter: {
//         enabled: true,
//         filterRange: [[fromTime.getTime(), toTime.getTime()]],
//         filterSoftRange: [[fromTime.getTime(), toTime.getTime()]],
//         filterTransform: (d: MaxPrecipDataFeature) => {
//           return [d.properties.time.getTime()];
//         },
//       },
//     })
//   );
// }
